import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { formatDuration } from '../utils/format';

// Segmented bar: each category (Productive/Unproductive/Neutral/Unrated)
// fills a proportional, differently-colored slice — "differential" colors
// showing the breakdown at a glance, not a single bar that just changes
// color at a threshold.
const SEGMENTS = [
    { key: 'productive', label: 'Productive', color: '#10B981' },
    { key: 'unproductive', label: 'Unproductive', color: '#EF4444' },
    { key: 'neutral', label: 'Neutral', color: '#F59E0B' },
    { key: 'unrated', label: 'Unrated', color: '#EF4444' },
];

export default function ProductivityBar({ productive = 0, unproductive = 0, neutral = 0, unrated = 0, sx }) {
    const values = { productive, unproductive, neutral, unrated };
    const total = productive + unproductive + neutral + unrated;
    const pct = (v) => (total > 0 ? (v / total) * 100 : 0);

    return (
        <Box sx={{ minWidth: 160, ...sx }}>
            <Box sx={{ display: 'flex', height: 8, borderRadius: 999, overflow: 'hidden', bgcolor: 'rgba(255,255,255,0.06)' }}>
                {total === 0 ? null : SEGMENTS.map((seg) => {
                    const width = pct(values[seg.key]);
                    if (width <= 0) return null;
                    return (
                        <Tooltip key={seg.key} title={`${seg.label}: ${formatDuration(values[seg.key])} (${Math.round(width)}%)`} arrow>
                            <Box sx={{ width: `${width}%`, bgcolor: seg.color, height: '100%' }} />
                        </Tooltip>
                    );
                })}
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                {total > 0 ? `${Math.round(pct(productive))}% productive` : 'No activity'}
            </Typography>
        </Box>
    );
}
